import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import pepData from './pepData.js'
import store from './store.js'
import { setInterval, setTimeout } from 'core-js';
import { parse } from 'querystring';
import jsPDF from 'jspdf'


// images to generate the action plan poster
import weeksImages from './base64/actionPlanImages.js'

Vue.config.productionTip = false
Vue.config.devtools = true;

//Create a PEP object and load it with JSON config data.
var PEP = function () {
  var self = this;
  this.data = pepData.data;
  this.config = pepData.config;
  this.ui_lang = pepData.ui_language[self.config.language.language];
  this.ui_lang_pages = self.ui_lang.pages;
  this.ui_lang_components = self.ui_lang.components;
  this.serviceEndpoint = self.config.services.serviceEndpoint;
  this.pepApp = null;
  this.currentPage = "Index.html";
  this.getposter_attempts = 0;
  this.addview_attempts = 0;
  this.notification_attempts = 0;
  this.saving = false;
  this.deviceready = false;
  this.menuopened = false;

  //Routing Functions
  this.gotoRoute = function (url) {
    if (pep.data.login.isLoggedIn) {
      router.push(url);
    }
  };

  this.goToPageByURL = function (newPageURL) {
    pep.ui_lang_components.login.loginerror = "";

    if (pep.data.login.isLoggedIn) {
      var pc = pep.config.defaultPages;

      var currentULR = "/" + window.location.hash.split('/')[1];

      if (currentULR == newPageURL)
        return;

      if (self.data.login.isLoggedIn) {
        pep.checkLoggedIn();
      }

      for (var i = 0; i < pc.length; i++) {
        pc[i].current = false;

        if (newPageURL == pc[i].url) {
          pc[i].current = true;
          //console.log(pc[i]);
        }
      }

      router.push(newPageURL);
    }
  };

  this.CordovaLinkOpen = function (link, self) {
    var ref = cordova.InAppBrowser.open(link, '_blank', 'location=no,toolbar=no,');

    //ref.addEventListener("loadstart", function (e) {
    //    console.log("loadstart >> addEventListener called");
    //}, false);

    //ref.addEventListener("loadstop", function (e) {
    //    console.log("loadstop >> addEventListener called");
    //}, false);

    //ref.addEventListener("loaderror", function (e) {
    //    console.log("loaderror >> addEventListener called");
    //}, false);

    //on exit - refresh progress
    ref.addEventListener("exit", function (e) {
      console.log("pep.initData()");
      console.log("exit >> addEventListener called");

      if (self != null) {
        console.log("temp_redirect: " + '/week/' + self.$route.params.curriculumid);
        pep.data.settings.temp_redirect = '/week/' + self.$route.params.curriculumid;
      }
     
      console.log("pep.refresh_GetCourseProgress()");
      pep.refresh_GetCourseProgress();
    }, false);

    //ref.addEventListener("beforeload", function (e) {
    //    console.log("beforeload >> addEventListener called");
    //}, false);

    ref.addEventListener("message", function (params) {
      console.log("message >> addEventListener called");

      if (params.data.action == 'close') {
        ref.close();
      }
    });

    return ref;
  }

  this.getCurrentRoute = function () {
    return router.currentRoute;
  };

  function initPEP() {
    //window.pepData = pepData;
    //retrieve the stored data if we have it

    //var retrievedObject = localStorage.getItem('pepData');
    //if (retrievedObject !== null) { self.data = JSON.parse(retrievedObject); }

    //Check if we're still logged in
    self.checkLoggedIn();

    //Initialise Vue
    //Start the main app
    window.addEventListener("DOMContentLoaded", function () {
      var pepApp = new Vue({
        router,
        store,
        render: h => h(App)
      }).$mount('#app');

      self.pepApp = pepApp;
    }, false);
  }

  //Language Functions
  this.getModelByPage = function (currentPage) {
    var pageModel = self.ui_lang.pages[currentPage];
    //var viewModel = ko.mapping.fromJS(langself.currentLangJSON);
    return pageModel;
  };

  //this.refreshToken = function () {
  //  //Now call refresh token
  //  $.ajax({
  //    url: self.serviceEndpoint + "/nidp/oauth/nam/token",
  //    method: "POST",
  //    data: $.param(userLogin),
  //    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  //    dataType: "json",
  //    crossDomain: true,
  //    async: true
  //  }).done(function (data) {
  //    //Set the login details
  //    self.pepApp.login.token.access_token = data.access_token;
  //    self.pepApp.login.token.token_type = data.token_type;
  //    self.pepApp.login.token.expires_in = data.expires_in;
  //    self.pepApp.login.token.scope = data.scope;
  //    self.pepApp.login.token.refresh_token = data.refresh_token;
  //    self.pepApp.login.token.userName = data.userName;
  //    self.pepApp.login.token.issued = data.issued;
  //    self.pepApp.login.token.expires = data.expires;
  //    self.pepApp.login.token.isLoggedIn = true;
  //    //Stop the loader running
  //    self.stopLoaderIndicator($('.login-form'));
  //  }).fail(function (data) {
  //    //self.ui_lang_components.login.loginerror = data.responseJSON.error_description;
  //    //Stop the loader running
  //    self.stopLoaderIndicator($('.login-form'));
  //  });
  //};

  //Register
  this.register = function (agreeterms, registerCode, username, pwd, email, firstname, lastname, salutation, callback) {
    self.ui_lang_components.login.registererror = "";
    //Start the loader running
    //self.startLoaderIndicator($('.login-form'));

    if (agreeterms == '' || registerCode == '' || username == '' || pwd == '' || email == '' || firstname == '' || lastname == '' || salutation == '') {
      self.ui_lang_components.login.loginerror = 'Please make sure there are no empty fields.';

      return;
    }

    //Now call token generation
    $.ajax({
      url: self.config.services.ServiceEndpoint + 'registerUser?agreeterms=' + agreeterms + '&registerCode=' + registerCode + '&username=' + username + '&pwd=' + encodeURIComponent(pwd) + '&email=' + email + '&firstname=' + firstname + '&lastname=' + lastname + '&salutation=' + salutation,
      method: "POST",
      dataType: "json",
      crossDomain: true,
      async: true
    }).done(function (data) {
      //callback data
      if (data.success) {
        callback(data);
      } else {
        //self.ui_lang_components.login.loginerror = 'Could not register you with that information, try a more complicated password';

        self.ui_lang_components.login.registererror = data.msg;

        if (data.msg.indexOf('Passwords must have at least one') != -1) {
          self.ui_lang_components.login.loginerror = "Passwords must have at least one special character (�, $, %), at least one number (0 - 9) and at least on uppercase letter (A - Z).";
        }

        //console.log(data.msg);
        //Could not register you with that information, try a more complicated password
      }
    }).fail(function (data) {
      //console.log(data);
      self.ui_lang_components.login.registererror = "Your registration failed, please check your details and try again";
      //Stop the loader running
      //self.stopLoaderIndicator($('.login-form'));
    });
  };

  this.logout = function () {
    pep.data.notifications = [];

    pep.data.login.isLoggedIn = false;
    localStorage.clear();
    pep.checkLoggedIn();
  };

  this.login = function (username, password) {
    //login to the debug system
    // self.ui_lang_components.login.loginerror = "";
    var userLogin = {
      grant_type: 'password',
      username: username,
      password: password
    };


    //Now call token generation
    $.ajax({
      url: pep.config.services.LoginEndPoint,
      method: "POST",
      data: $.param({ grant_type: 'password', username: userLogin.username, password: userLogin.password }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      async: false
    }).done(function (data) {
      pep.data.login.isLoggedIn = true;
      self.data.login.token.username = username;
      self.data.login.token.access_token = data.access_token;
      self.data.login.token.expires_in = data.expires_in;
      self.data.login.token.refresh_token = data.refresh_token;
      self.data.login.token.issued = Date.now();
      self.data.login.token.expires = data.expires_in;

      self.getProfileFields(self.loginSuccess, self.loginFailed);

    }).fail(function (data) {
      self.ui_lang_components.login.loginerror = "Your Username or Password was not recognised, please try again";
    });
  };


  this.getProfileFields = function (callbackSuccess, callbackFailed) {
    //Get the user record
    $.ajax({
      url: self.config.services.ServiceEndpoint + 'getProfileFields?username=' + self.data.login.token.username,
      type: 'GET',
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', 'Bearer ' + self.data.login.token.access_token);
      },
      success: function (data) {
        pep.data.userdetail = data;

        if (typeof callbackSuccess == "function")
          callbackSuccess();

      },
      error: function () {
        if (typeof callbackFailed == "function")
          callbackFailed();
      },
    });
  }

  //Get Profile
  this.getAppSettings = function (username, callback) {

    $.ajax({
      url: self.config.services.ServiceEndpoint + 'getAppSettings?username=' + username,
      method: "GET",
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      dataType: "json",
      crossDomain: true,
      async: false
    }).done(function (data) {
      //done
      if (data != "") {

        for (const [key, value] of Object.entries(data)) {
          self.data.settings[key] = value;
        }

      }

      if (typeof callback == "function")
        callback();

    }).fail(function (data) {
      //faled

      if (typeof callback == "function")
        callback();
    }).always(function (data) {
      //always run
    });
  };

  this.loginSuccess = function () {
    localStorage.clear();

    self.initData();
  }

  this.loginFailed = function () {

  }

  this.recoverUsername = function (email) {

    self.ui_lang_components.login.recovererror = '';
    self.ui_lang_components.login.recoversuccess = '';

    if (email == '') {
      self.ui_lang_components.login.recovererror = 'Please make sure there are no empty fields.';
      return;
    }

    if (validateEmail(email) == false) {
      self.ui_lang_components.login.recovererror = 'Please make sure the email is in the right format.';
      return;
    }

    if ($("#btnRecoverPassword").hasClass("disabled") == false) {

      self.ui_lang_components.login.recovererror = 'Loading...';

      $("#btnRecoverPassword").addClass("disabled");

      $.ajax({
        url: self.config.services.ServiceEndpoint + 'getForgotUsername?email=' + email,
        method: "GET",
        dataType: "json",
        crossDomain: true,
        async: true
      }).done(function (data) {
        //console.log(data);
        self.ui_lang_components.login.recoversuccess = '';
        self.ui_lang_components.login.recovererror = '';

        if (data == "Error occured.") {
          self.ui_lang_components.login.recoversuccess = '';
          self.ui_lang_components.login.recovererror = 'Process failed, please check your details and try again';

          $("#btnRecoverPassword").removeClass("disabled");

        } else {
          $(".recover-password-form").find(".form-group").hide();

          self.ui_lang_components.login.recovererror = '';
          self.ui_lang_components.login.recoversuccess = 'Please check your email for the link to reset your username!';
        }

      }).fail(function (data) {
        self.ui_lang_components.login.recoversuccess = '';
        self.ui_lang_components.login.recovererror = 'Process failed, please check your details and try again';
        $("#btnRecoverPassword").removeClass("disabled");
      });

    }

  };

  this.recoverPassword = function (email) {

    self.ui_lang_components.login.recovererror = '';
    self.ui_lang_components.login.recoversuccess = '';

    if (email == '') {
      self.ui_lang_components.login.recovererror = 'Please make sure there are no empty fields.';
      return;
    }

    if (validateEmail(email) == false) {
      self.ui_lang_components.login.recovererror = 'Please make sure the email is in the right format.';
      return;
    }

    if ($("#btnRecoverPassword").hasClass("disabled") == false) {

      self.ui_lang_components.login.recovererror = 'Loading...';

      $("#btnRecoverPassword").addClass("disabled");

      $.ajax({
        url: self.config.services.ServiceEndpoint + 'getForgotPasswordToken?email=' + email,
        method: "GET",
        dataType: "json",
        crossDomain: true,
        async: true
      }).done(function (data) {
        //console.log(data);

        if (data == "Error occured.") {
          self.ui_lang_components.login.recovererror = 'Process failed, please check your details and try again';
          $("#btnRecoverPassword").removeClass("disabled");

        } else {
          $(".recover-password-form").find(".form-group").hide();

          self.ui_lang_components.login.recovererror = '';
          self.ui_lang_components.login.recoversuccess = 'Please check your email for the link to reset your password!';
        }

      }).fail(function (data) {
        self.ui_lang_components.login.recoversuccess = '';
        self.ui_lang_components.login.recovererror = 'Process failed, please check your details and try again';
        $("#btnRecoverPassword").removeClass("disabled");
      });

    }

  };

  this.resetPassword = function (newPwd) {

    self.ui_lang_components.login.reseterror = "";
    self.ui_lang_components.login.resetsuccess = "";

    if (newPwd == '') {
      self.ui_lang_components.login.reseterror = 'Please make sure there are no empty fields.';
      return;
    }

    if (validatePassword(newPwd) == false) {
      self.ui_lang_components.login.reseterror = 'Passwords must have at least one special character (�, $, %), at least one number (0 - 9) and at least on uppercase letter (A - Z).';
      return;
    }

    var userid = getParameterByName("userId", window.location.href);
    var token = encodeURIComponent(getParameterByName("token", window.location.href));

    if (userid == "" || token == "") {
      self.ui_lang_components.login.reseterror = 'Invalid link please access your email and click again.';
      return;
    }

    if ($("#btnResetPassword").hasClass("disabled") == false) {

      self.ui_lang_components.login.reseterror = 'Loading...';

      $("#btnResetPassword").addClass("disabled");

      $.ajax({
        url: self.config.services.ServiceEndpoint + 'resetPassword?userid=' + userid + "&newPwd=" + encodeURIComponent(newPwd) + "&token=" + token,
        method: "POST",
        dataType: "json",
        crossDomain: true,
        async: true
      }).done(function (data) {
        //console.log(data);

        if (data == 200) {
          $(".reset-password-form").find(".form-group").hide();
          self.ui_lang_components.login.resetsuccess = 'Password saved successfully!';
        } else {
          if (data == "Error occured.") {
            self.ui_lang_components.login.reseterror = 'Process failed, please check your details and try again';
            $("#btnResetPassword").removeClass("disabled");
          } else {

            self.ui_lang_components.login.reseterror = data;
            self.ui_lang_components.login.resetsuccess = "";
            $("#btnResetPassword").removeClass("disabled");
          }
        }

      }).fail(function (data) {
        self.ui_lang_components.login.reseterror = 'Process failed, please check your details and try again';
        $("#btnResetPassword").removeClass("disabled");
      });

    }

  };

  this.initData = function () {
    router.push('/loading');

    self.setupCurriculums(self.data.userdetail.CompanyID, 1, self.data.userdetail.ID, self.data.userdetail.GUID, self.data.userdetail.UserName);
    self.getNotifications(self.insertNotifications, self.getNotificationFailed);
    self.getAppSettings(self.data.userdetail.UserName);
  };


  this.cordovainit = function () {
    //Initialise any cordova specific functionality
    self.deviceready = true;

    if (window.MobileAccessibility) {
      window.MobileAccessibility.usePreferredTextZoom(false);
    }

    var notificationOpenedCallback = function (jsonData) {
      //console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));jules26
    };

    document.addEventListener("pause", self.onPause, false);
    document.addEventListener("resume", self.onResume, false);
  };

  this.onPause = function () {
    //We need to save the data for resuming in case of exit.
  };

  this.onResume = function () {
    //self.checkLoggedIn();
    //console.log("resume");

    //we're resuming the app, probably a good time to check on the status.
    //But the token has likely expired so let's test with a refresh token.
    if (self.data.login.isLoggedIn) {
      self.initData();
    }
  };


  this.setupCurriculums = function(companyId, termId, userId, user_fk, username) {

    var image_curriculumn_URL = self.config.services.generalURLImage;

    //Get the curriculums
    var JobTitle_FK = pep.data.userdetail.JobTitle_FK;

    $.ajax({
      url: self.config.services.ServiceEndpoint + 'getCurriculumsByTerm?USR_COMPANY_FK=' + companyId + '&TERM_ID= ' + termId,
      type: 'GET',
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', 'Bearer ' + self.data.login.token.access_token);
      },
      success: function (data) {

        var curriculumns = data;

        //Order by Level
        curriculumns.sort(function (a, b) {
          return a.orderno - b.orderno;
        });

        // set first curriculum to be full width storyboard image
        if (curriculumns.length > 0)
          curriculumns[0].topFeaturedFullWidth = true;

        $.when(getCoursesInCurriculumns(), getUserItem(user_fk), getStoryBoardImages(username), getGameplanData(username), getLRS_Courses_Stats(username), getQuizQuestionsByJobTitle_FK(JobTitle_FK))
          .done(function (catalogLinksData, UserItemData, StoryBoardImages, GameplanData, LRS_Courses_Stats, QuizQuestions) {

            catalogLinksData = catalogLinksData[0];
            StoryBoardImages = StoryBoardImages[0];
            LRS_Courses_Stats = LRS_Courses_Stats[0];
            QuizQuestions = QuizQuestions[0];

            self.data.userdetail.UserItemId = UserItemData[0]["Id"];

            if (QuizQuestions != null) {
              pep.data.quizquestions = QuizQuestions;
            }

            if (GameplanData[0] != "Nothing found" && GameplanData[0] != null && IsJsonString(GameplanData[0])) {
              var parsedData = JSON.parse(GameplanData[0]);
              if (typeof parsedData == "object") {

                localStorage.setItem('actionPlan', GameplanData[0]);
                pep.data.categories = parsedData;
              } else {
                console.error("main.js actionplan not an object");
              }
            } else {
              console.error("main.js actionplan data not parsed, using default");

              console.log("Saving default action plan data..")
              setGameplanData(username).done(function (data, status) {
                console.log("SAVED " + data);
              });
            }

            $.when(getCourseScores(self.data.userdetail.UserItemId)).done(function (CourseScores) {

              catalogLinksData.forEach(function (course, index) {

                course.courseid = course.CourseID;
                course.curriculumid = course.Curriculum_ID_FK;

                course.coursename = course.CourseName;
                course.coursedescription = course.CourseDescription;
                course.coverimage = image_curriculumn_URL + course.M_FILE_PATH;

                course.userrating = 5;
                course.certificationid = 1;
                course.locationdir = course.LocationDir;
                //course.progressData = CourseScores.filter(score => score.CourseID == course.CourseID);
                course.progressData = CourseScores.filter(function (score) {
                  return score.CourseID == course.CourseID;
                });

                course.mandatory = course.Mandatory;
                course.progress = 0;
                course.isCompleted = false;

                //LMS PROGRESS
                if (course.progressData != null) {
                  if (course.progressData.length != 0) {

                    var cPd_Index = (course.progressData.length - 1);

                    course.progress = (course.progressData[cPd_Index].XMLProgress == null ? 0 : (course.progressData[cPd_Index].XMLProgress * 100));

                    if (course.progress == 0)
                      course.progress = (course.progressData[cPd_Index].XMLRawScore == null ? 0 : (course.progressData[cPd_Index].XMLRawScore * 100));

                    if (course.progressData[cPd_Index].XMLLessonStatus == "completed" || course.progressData[cPd_Index].XMLCompletionStatus == "completed") {
                      //console.log(course.CourseID);
                      //console.log(course.CourseName);
                      //console.log(course.progressData[0].XMLLessonStatus);
                      course.progress = 100;
                      course.isCompleted = true;
                    }

                  }
                }

                //LRS PROGRESS

                if (course.DeepLinkURL != '' && LRS_Courses_Stats != null) {
                  //console.group('Group start');
                  var isLRS_Data_Present = LRS_Courses_Stats.filter(function (stat) {
                    return stat.INTERNAL_ID == course.courseid
                  });

                  if (isLRS_Data_Present.length > 0) {
                    course.progress = 100;
                    course.isCompleted = true;
                  }
                }

                course.deliverytype = "pdf";
                course.class = "bronze";
              });

              curriculumns.forEach(function (curriculumn, index) {
                var curriculumId = curriculumn.id;
                var curriculumLevel = curriculumn.level;

                var CurriculumnProgress = 0;

                console.log(curriculumns.url);

                //Story board images - uncomment if needed
                //var StoryBoardImageID = 0;
                //StoryBoardImages.forEach(function (s_elem, s_index) {
                //    var key_id = s_elem.key.split('_')[1];

                //    if (key_id == curriculumLevel)
                //        StoryBoardImageID = s_index;
                //});

                var courses = catalogLinksData.filter(function (elem) {
                  return elem.Curriculum_ID_FK == curriculumId
                });

                //console.log(courses);

                courses.forEach(function (elem) {
                  CurriculumnProgress += elem.progress;
                });

                curriculumn.progress = CurriculumnProgress / courses.length;

                courses.sort(function (a, b) {
                  return a.OrderNo - b.OrderNo || a.Attached.localeCompare(b.Attached);
                });

                curriculumn.courses = courses;

                if (curriculumn.id != 397 && curriculumn.id != 398)
                  curriculumn.week = "Session " + curriculumn.level;

                curriculumn.tileURL = image_curriculumn_URL + curriculumn.image1_landscape;

                //if (StoryBoardImageID != 0) {
                //    if (StoryBoardImages[StoryBoardImageID].Text !== null) {
                //        curriculumn.tileURL = StoryBoardImages[StoryBoardImageID].Text;
                //    }
                //}
              });

              if (termId == 1) {
                pep.data.curriculums = curriculumns;

                if (pep.data.settings.temp_redirect == "") {
                  router.push('/home');
                  self.save();

                } else {
                  var tmproute = pep.data.settings.temp_redirect;
                  pep.data.settings.temp_redirect = "";

                  window.setTimeout(function () { router.push(tmproute); }, 200);
                }
              }

              if (termId == 2) {
                pep.data.curriculums2 = curriculumns;
              }

            });

          });

      },
      error: function () { }
    });
  }


  this.refresh_CourseProgress = function () {
    if (self.data.userdetail.UserItemId == null) {
      console.error("UserItemId is null.")
      console.log("getUserItem...")

      $.when(getUserItem(self.data.userdetail.GUID)).done(function (UserItem) {
        console.log(UserItem);
        self.data.userdetail.UserItemId = UserItem;

        self.refresh_GetCourseProgress();
      });

      return;
    } else {
      self.refresh_GetCourseProgress();
    }
  }

  this.refresh_GetCourseProgress = function () {

    $.when(getCourseScores(self.data.userdetail.UserItemId)).done(function (CourseScores) {
      //catalogLinksData = catalogLinksData[0];

      self.data.curriculums.forEach(function (curriculum) {
        //console.log(curriculum);

        var CurriculumProgress = 0;

        curriculum.courses.forEach(function (course) {
          //console.log(course);

          var courseScore = CourseScores.filter(function (cs) {
            return cs.CourseID == course.CourseID
          });


          if (courseScore.length > 0) {
            courseScore = courseScore[0];

            course.progress = (courseScore.XMLProgress == null ? 0 : (courseScore.XMLProgress * 100));

            if (course.progress == 0)
              course.progress = (courseScore.XMLRawScore == null ? 0 : (courseScore.XMLRawScore * 100));

            if (courseScore.XMLLessonStatus == "completed" || courseScore.XMLCompletionStatus == "completed") {
              course.progress = 100;
              course.isCompleted = true;
            }
          }

          CurriculumProgress += course.progress;
        });

        curriculum.progress = CurriculumProgress / curriculum.courses.length;
      });

      if (pep.data.settings.temp_redirect == "") {
        router.push('/home');
        self.save();

      } else {
        var tmproute = pep.data.settings.temp_redirect;
        pep.data.settings.temp_redirect = "";

        window.setTimeout(function () { router.push(tmproute); }, 200);
      }

    });
  }

  //Get catalog and curriculumns links
  function getUserItem(USR_ID_FK) {
    return $.ajax({
      url: self.config.services.ServiceEndpoint + 'getUserItem?USR_ID_FK=' + USR_ID_FK,
      type: 'get',
      beforesend: function (xhr) {
        xhr.setrequestheader('authorization', 'bearer ' + self.data.login.token.access_token);
      }
    });
  }

  function getCoursesInCurriculumns() {
    return $.ajax({
      url: self.config.services.ServiceEndpoint + 'getCoursesCurriculumsLinks',
      type: 'GET',
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', 'Bearer ' + self.data.login.token.access_token);
      }
    });
  }

  function getCourseScores(UserItemID) {
    return $.ajax({
      url: self.config.services.ServiceEndpoint + 'getIndividualScores?useritemid=' + UserItemID,
      type: 'get',
      beforesend: function (xhr) {
        xhr.setrequestheader('authorization', 'bearer ' + self.data.login.token.access_token);
      }
    });
  }

  function getStoryBoardImages(username) {
    return $.ajax({
      url: self.config.services.ServiceEndpoint + 'listStoryBoardItems?username=' + username,
      method: "POST",
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      dataType: "json",
      crossDomain: true,
      async: true
    });
  }

  function getGameplanData(username) {
    return $.ajax({
      url: self.config.services.ServiceEndpoint + 'getGameplanData?username=' + username,
      type: 'get',
      beforesend: function (xhr) {
        xhr.setrequestheader('authorization', 'bearer ' + self.data.login.token.access_token);
      }
    });
  }

  function setGameplanData(username) {

    if (pep.data.categories == null || typeof pep.data.categories != "object")
      return;

    var data = {
      username: username,
      gameplanJson: JSON.stringify(pep.data.categories)
    }

    localStorage.setItem('actionPlan', JSON.stringify(self.categories));

    return $.ajax({
      url: self.config.services.ServiceEndpoint + 'setGameplanData',
      method: "POST",
      data: data,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      dataType: "json",
      crossDomain: true,
      async: true
    });
  }

  function getLRS_Courses_Stats(username) {
    return $.ajax({
      url: self.config.services.ServiceEndpoint + 'getLRS_Courses_Stats?username=' + username,
      type: 'get',
      beforesend: function (xhr) {
        xhr.setrequestheader('authorization', 'bearer ' + self.data.login.token.access_token);
      }
    });
  }

  function getQuizQuestionsByJobTitle_FK(JobTitle_FK) {
    return $.ajax({
      url: self.config.services.ServiceEndpoint + 'getQuizQuestionsByJobTitle_FK?JobTitle_FK=' + JobTitle_FK,
      method: "GET",
      dataType: "json",
      crossDomain: true,
      async: true
    });
  }

  this.LoadQuestions = function () {
    return $.ajax({
      url: self.config.services.ServiceEndpoint + 'getDNAQuizQuestions',
      method: "GET",
      dataType: "json",
      crossDomain: true,
      async: true
    });
  }

  this.LoadAnswers = function () {
    return $.ajax({
      url: self.config.services.ServiceEndpoint + 'getDNAQuizAnswers',
      method: "GET",
      dataType: "json",
      crossDomain: true,
      async: true
    });
  }

  this.LoadQuizzes = function () {
    return $.ajax({
      url: self.config.services.ServiceEndpoint + 'getDNAQuizzes',
      method: "GET",
      dataType: "json",
      crossDomain: true,
      async: true
    });
  }

  this.LoadQuizzesPerRole = function () {
    return $.ajax({
      url: self.config.services.ServiceEndpoint + 'getDNAQuizForJobs',
      method: "GET",
      dataType: "json",
      crossDomain: true,
      async: true
    });
  }

  this.LoadQuizSets = function () {
    return $.ajax({
      url: self.config.services.ServiceEndpoint + 'getDNAQuizSets',
      method: "GET",
      dataType: "json",
      crossDomain: true,
      async: true
    });
  }

  this.getTokenValidation = function () {
    return $.ajax({
      url: self.config.services.ServiceEndpoint + 'getTokenValidation',
      type: 'GET',
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', 'Bearer ' + self.data.login.token.access_token);
      }
    });
  }

  this.getUserQuizzes = function (JobName) {
    var role = pep.data.userdetail.JobTitle;

    if (typeof role != "string") {
      console.error("Invalid quiz jobtitle.");
      return;
    }

    pep.LoadDNAQuizzesPerRole().done(function (data) {

      var UserQuizzes = data.filter(function (e) {
        return e.JT_JobTitle == role;
      });

      console.log(">> UserQuizzes");
      console.log(UserQuizzes);
    });
  }

  this.getUserQuizSets = function (quizID) {

    if (typeof quizID != "number") {
      console.error("Invalid quiz id.");
      return;
    }

    pep.LoadQuizSets().done(function (data) {

      var QuizSets = data.filter(function (e) {
        return e.QuizID == quizID;
      });

      console.log(">> user QuizSets");
      console.log(QuizSets);
    });

  }

  this.sendSurvey = function (quizResponses, QS_ID, callback) {
    return $.ajax({
      url: self.config.services.ServiceEndpoint + 'postQuizResults?QS_ID=' + QS_ID,
      data: quizResponses,
      method: "POST",
      dataType: "json",
      contentType: "application/json"
    }).done(function (data, textStatus, jqXHR) {
      console.log("survey sent done");
      console.log(data);
      console.log(textStatus);
      console.log(jqXHR);

      if (typeof callback == 'function')
        callback(data);

    }).fail(function () {
      //connection timeout
      if (typeof callback == 'function')
        callback(408);
    });
  };

  this.sendStudentQuestionnaireResponses = function (area1, area2, area3, area4, area5, area6, area7, area8, area9, applied, appliedDetail, improveLearning, userid) {

    var questionnaire = '3001=' + area1 + '&3002=' + area2 + '&3003=' + area3 + '&3004=' + area4 +
      '&3005=' + area5 + '&3006=' + area6 + '&3007=' + area7 + '&3008=' + area8 + '&3009=' +
      area9 + '&3010=' + applied + '&3011=' + appliedDetail + '&3012=' + improveLearning + '&userid=' + userid;

    var pairs = questionnaire.split('&');

    var result = {};
    pairs.forEach(function (pair) {
      pair = pair.split('=');
      result[pair[0]] = decodeURIComponent(pair[1] || '');
    });
    questionnaire = result;

    $.ajax({

      url: self.config.services.ServiceEndpoint + 'questionnaireResponses?questionnaire=' + encodeURIComponent(JSON.stringify(result)),
      method: "POST",
      dataType: "json",
      contentType: "application/json"
    });
  };


  this.sendStudentQuestionnaireResponsesTerm2 = function (area1, area2, area3, area4, area5, area6, area7, area8, area9, applied, appliedDetail, improveLearning, enjoyedLearning, userid) {

    var questionnaire = '6001=' + area1 + '&6002=' + area2 + '&6003=' + area3 + '&6004=' + area4 +
      '&6005=' + area5 + '&6006=' + area6 + '&6007=' + area7 + '&6008=' + area8 + '&6009=' +
      area9 + '&6010=' + applied + '&6011=' + appliedDetail + '&6012=' + improveLearning + '&6013' + enjoyedLearning + '&userid=' + userid;

    var pairs = questionnaire.split('&');

    var result = {};
    pairs.forEach(function (pair) {
      pair = pair.split('=');
      result[pair[0]] = decodeURIComponent(pair[1] || '');
    });
    questionnaire = result;

    $.ajax({

      url: self.config.services.ServiceEndpoint + 'questionnaireResponsesTerm2?questionnaire=' + encodeURIComponent(JSON.stringify(result)),
      method: "POST",
      dataType: "json",
      contentType: "application/json"
    });
  };

  this.sendFacilitatorQuestionnaireResponses = function (recommend, changes1, changes2, changes3, changes4, changes5, changes6, changes7, changes8, changes9, improve, additionalSupport, userid) {

    var questionnaire = '4001=' + recommend + '&4002=' + changes1 + '&4003=' + changes2 + '&4004=' +
      changes3 + '&4005=' + changes4 + '&4006=' + changes5 + '&4007=' + changes6 + '&4008=' +
      changes7 + '&4009=' + changes8 + '&4010=' + changes9 + '&4011=' + improve + '&4012=' + additionalSupport + '&userid=' + userid;

    var pairs = questionnaire.split('&');

    var result = {};
    pairs.forEach(function (pair) {
      pair = pair.split('=');
      result[pair[0]] = decodeURIComponent(pair[1] || '');
    });
    questionnaire = result;

    $.ajax({

      url: self.config.services.ServiceEndpoint + 'questionnaireResponses?questionnaire=' + encodeURIComponent(JSON.stringify(result)),
      method: "POST",
      dataType: "json",
      contentType: "application/json"
    });
  };

  this.sendFacilitatorQuestionnaireResponsesTerm2 = function (recommend, changes1, changes2, changes3, changes4, changes5, changes6, changes7, changes8, changes9, improve, additionalSupport, userid) {

    var questionnaire = '8001=' + recommend + '&8002=' + changes1 + '&8003=' + changes2 + '&8004=' +
      changes3 + '&8005=' + changes4 + '&8006=' + changes5 + '&8007=' + changes6 + '&8008=' +
      changes7 + '&8009=' + changes8 + '&8010=' + changes9 + '&8011=' + improve + '&8012=' + additionalSupport + '&userid=' + userid;

    var pairs = questionnaire.split('&');

    var result = {};
    pairs.forEach(function (pair) {
      pair = pair.split('=');
      result[pair[0]] = decodeURIComponent(pair[1] || '');
    });
    questionnaire = result;

    $.ajax({

      url: self.config.services.ServiceEndpoint + 'questionnaireResponsesTerm2?questionnaire=' + encodeURIComponent(JSON.stringify(result)),
      method: "POST",
      dataType: "json",
      contentType: "application/json"
    });
  };

  this.checkSurvey = function (UserID, QS_ID, callback) {
    $.ajax({
      url: self.config.services.ServiceEndpoint + 'postHasQuizSetResult?UserID=' + UserID + '&QS_ID=' + QS_ID,
      method: "POST",
      dataType: "json",
      contentType: "application/json"
    }).done(function (isCompleted) {
      if (typeof callback == 'function')
        callback(isCompleted);
    }).fail(function () {
      if (typeof callback == 'function')
        callback(false);
    });
  };

  this.checkSurveyTerm2 = function () {
    var bool = false
    //console.log('1: ' + pep.data.userid)
    //console.log('2: ' + pep.data.userdetail.ID)
    $.ajax({
      url: self.config.services.ServiceEndpoint + 'checkQuestionnaireresponseTerm2?userid=' + encodeURIComponent(pep.data.userdetail.ID),
      //data: JSON.stringify({ 'questionnaire': result }),
      method: "POST",
      dataType: "json",
      contentType: "application/json"
    }).done(function (data) {
      //console.log(data);  // this is currently returning FALSE
      //console.log('a')
      // Which is totally correct!
      if (data == true) {
        bool = true;
        pep.gotoRoute('/questionnaireComplete');
        return bool;
      }
    }).fail(function () {
      //console.log('b')
      bool = false;
      return bool;
    });
  };

  this.checkSurveyForMenu = function () {
    var bool = false
    //console.log('1: ' + pep.data.userid)
    //console.log('2: ' + pep.data.userdetail.ID)
    $.ajax({
      url: self.config.services.ServiceEndpoint + 'checkQuestionnaireresponse?userid=' + encodeURIComponent(pep.data.userdetail.ID),
      //data: JSON.stringify({ 'questionnaire': result }),
      method: "POST",
      dataType: "json",
      contentType: "application/json"
    }).done(function (data) {
      //console.log(data);  // this is currently returning FALSE
      //console.log('a')
      // Which is totally correct!
      if (data == true) {
        bool = true;
        pep.gotoRoute('/home_part_two');
        return bool;
      }
    }).fail(function () {
      //console.log('b')
      bool = false;
      return bool;
    });
  };

  this.checkLoggedIn = function () {
    console.log("self.data.login.isLoggedIn: " + self.data.login.isLoggedIn);

    //if logged and trying to access login page
    //if (self.data.login.isLoggedIn &&
    //  window.location.hash != "#/home" &&
    //  window.location.hash == "#/") {
    //  self.gotoRoute("/home");

    //  return;
    //}

    //transfer to the main domain START
    if (window.location.hostname != "localhost" &&
      window.location.hostname.indexOf("ivyhouselms") == -1 &&
      window.location.href.indexOf("purplemediacloud.co.uk/clients/ivyhouse/app") == -1 &&
      window.location.href.indexOf("uat") == -1) {

      if (typeof cordova == 'undefined') {
        //if (window.location.origin != "http://ivyhouse-uat-v2.purplemediahosting.co.uk") {
        //  window.location.href = window.location.href.replace(window.location.origin, "http://ivyhouse-uat-v2.purplemediahosting.co.uk");
        //}
      }
    }
    //transfer to the main domain END

    //ignore password recover/reset pages/GAMEPLAN pages doesnt require login start
    if (window.location.href.indexOf('password_recover') != -1 ||
      window.location.href.indexOf('lmsstudentview') != -1 ||
      window.location.href.indexOf('password_reset') != -1) {

      return;
    }
    else {
      if (!self.data.login.isLoggedIn) {
        if (window.location.hash != "#/")
          router.push("/");
      }
    }

    if (window.location.href.indexOf('password_reset') == -1 && window.location.href.indexOf('password_recover') == -1) {
      var mainPageHasIframe = document.getElementsByTagName('iframe');

      if (mainPageHasIframe.length > 0 && self.data.login.isLoggedIn == true) {
        setPepObjToIframe();
      } else {
        if (inIframe() == false) {
          if (window.location.hash != "#/")
            router.push("/");
        }
      }
    }

  };


  //this.getStartedCourses = function (companyID, termId, successcallback, failedcallback) {
  //  //check the token
  //  //self.checkToken();
  //  //first add a running service count
  //  self.config.services.currentlyRunning += 1;
  //  self.learnerhistory_attempts += 1;

  //  $.ajax({
  //    url: self.config.services.ServiceEndpoint + 'getCurriculumsByTerm?USR_COMPANY_FK=' + companyID + '&TERM_ID=' + termId,
  //    method: "GET",
  //    data: $.param(userLogin),
  //    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  //    dataType: "json",
  //    crossDomain: true,
  //    async: true
  //  }).done(function (data) {
  //    if (data === null) {
  //      if (self.getcurriculums_attempts <= self.config.services.max_retrys) {
  //        //Try again in .75 seconds
  //        setTimeout(function () { self.getLearnerHistory(successcallback, failedcallback); }, 250);
  //      } else {
  //        self.getcurriculums_attempts = 0;
  //        if (typeof failedcallback != 'undefined') { failedcallback(data); }
  //      }
  //    } else {
  //      //Set the redware data
  //      self.getcurriculums_attempts = 0;
  //      if (typeof successcallback != 'undefined') { successcallback(data); }
  //    }
  //  }).fail(function (data) {
  //    if (self.getcurriculums_attempts <= self.config.services.max_retrys) {
  //      //Try again in .75 seconds
  //      setTimeout(function () { self.getLearnerHistory(successcallback, failedcallback); }, 250);
  //    } else {
  //      self.getcurriculums_attempts = 0;
  //      if (typeof failedcallback != 'undefined') { failedcallback(data); }
  //    }
  //  }).always(function () {
  //    //first show were doing something
  //    self.config.services.currentlyRunning -= 1;
  //  });
  //};

  //this.startLoaderIndicator = function (elem) {
  //  //$('.ajax_loader').addClass("enabled");
  //  //elem.css("opacity", 0.5);
  //};

  //this.stopLoaderIndicator = function (elem) {
  //  $('.ajax_loader').removeClass("enabled");
  //  elem.css("opacity", 1);
  //};

  //alerts
  //this.showMessage = function (msgtype, msg) {
  //  alert("THIS NEEDS PRETTYING UP: " + msg);
  //};


  this.getPosterImages = function (successcallback, failedcallback) {

    //first add a running service count
    self.config.services.currentlyRunning += 1;
    self.learnerhistory_attempts += 1;

    var username = self.data.login.token.username;

    $.ajax({
      url: self.config.services.ServiceEndpoint + 'listStoryBoardItems?username=' + username,
      method: "POST",
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      dataType: "json",
      crossDomain: true,
      async: true
    }).done(function (data) {
      if (data === null) {
        if (self.getposter_attempts <= self.config.services.max_retrys) {
          //Try again in .75 seconds
          setTimeout(function () { self.getPosterImages(successcallback, failedcallback); }, 250);
        } else {
          self.getposter_attempts = 0;
          if (typeof failedcallback != 'undefined') { failedcallback(data); }
        }
      } else {
        //Set the redware data
        self.getposter_attempts = 0;
        pep.data.storyboardimages = data;
        if (typeof successcallback != 'undefined') { successcallback(data); }
      }
    }).fail(function (data) {

      if (self.getposter_attempts <= self.config.services.max_retrys) {
        //Try again in .75 seconds
        setTimeout(function () { self.getPosterImages(successcallback, failedcallback); }, 250);
      } else {
        self.getposter_attempts = 0;
        if (typeof failedcallback != 'undefined') { failedcallback(data); }
      }
    }).always(function () {
      //first show were doing something
      self.config.services.currentlyRunning -= 1;
    });
  };

  this.setUDF = function (udfNo, udfValue, successcallback, failedcallback) {
    var username = self.data.login.token.username;
    $.ajax({
      url: self.config.services.ServiceEndpoint + 'setUDF?username=' + username + '&udfNo=' + udfNo + '&udfvalue=' + udfValue,
      method: "POST",
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      dataType: "json",
      crossDomain: true,
      async: false
    }).done(function (data) {
      if (typeof successcallback != 'undefined') { successcallback(data); }
    }).fail(function (data) {
      if (typeof failedcallback != 'undefined') { failedcallback(data); }
    });
  };

  this.setLike = function (objecttype, objectid, callback, currentLikes) {
    var username = self.data.login.token.username;
    $.ajax({
      url: self.config.services.ServiceEndpoint + 'setLike?username=' + username + '&objecttype=' + objecttype + '&ObjectID=' + objectid,
      method: "POST",
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      dataType: "json",
      crossDomain: true,
      async: false
    }).done(function (data) {
      callback(data);
    }).fail(function (data) {
      callback(currentLikes);
    });
  };

  this.unsetLike = function (objecttype, objectid, callback) {
    var username = self.data.login.token.username;
    $.ajax({
      url: self.config.services.ServiceEndpoint + 'unsetLike?username=' + username + '&objecttype=' + objecttype + '&ObjectID=' + objectid,
      method: "POST",
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      dataType: "json",
      crossDomain: true,
      async: false
    }).done(function (data) {
      callback(data);
    }).fail(function (data) {
      callback(-1);
    });
  };

  this.getLikes = function (objecttype, objectid, callback) {
    $.ajax({
      url: self.config.services.ServiceEndpoint + 'getLikes?ObjectType=' + objecttype + '&ObjectID=' + objectid,
      method: "GET",
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      dataType: "json",
      crossDomain: true,
      async: false
    }).done(function (data) {
      callback(data);
    }).fail(function (data) {
      callback(-1);
    });
  };

  this.addView = function (courseID, successcallback, failurecallback) {
    var username = self.data.login.token.username;

    if (username == null || username == 'undefined') {
      console.error("User not found");
      return;
    }

    $.ajax({
      url: self.config.services.ServiceEndpoint + 'addViewCourse?username=' + username + '&courseID=' + courseID,
      method: "POST",
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      dataType: "json",
      crossDomain: true,
      async: true
    }).done(function (data) {
      console.log("addView with courseID " + courseID + " for username " + username + " fired successfully.")
    }).fail(function (data) {
      console.error("addView with courseID " + courseID + " for username " + username + " failed to send.")
    });
  };

  this.addLaunch = function (courseID, success, fail) {
    var username = self.data.login.token.username;

    if (username == null || username == 'undefined') {
      console.error("User not found");
      return;
    }

    $.ajax({
      url: self.config.services.ServiceEndpoint + 'addLaunchCourse?username=' + username + '&courseID=' + courseID,
      method: "POST",
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      dataType: "json",
      crossDomain: true,
      async: true
    }).done(function (data) {
      console.log("addLaunch with courseID " + courseID + " for username " + username + " fired successfully.")
    }).fail(function (data) {
      console.error("addLaunch with courseID " + courseID + " for username " + username + " failed to send.")
    });
  };

  this.emailRegistration = function (to, USR, PWD, successcallback, failedcallback) {
    //Formulate email and send

    var recipient = to;
    var cc = "";
    var replyto = "";
    var subject = "Ivy House Register";
    var body = "";
    body += "<p>Welcome to the Ivy House family, it’s great to have you and we hope you enjoy the learning in The Award.</p>";
    body += "<p>We all know that remembering passwords and user names can be a pain, so we’re sharing these with you now. Be sure to save them or write them in your journal just in case your memory fails you.</p>";
    body += "<p>Username: " + USR;
    body += "<br/>Password: " + PWD + "</p>";
    body += "<p>The Ivy House Team.</p>";

    var filecontent = "";
    var filename = "";

    self.sendmsg(recipient, cc, replyto, subject, body, filecontent, filename, successcallback, failedcallback);
  };

  this.sendmsg = function (recipient, cc, replyto, subject, body, filecontent, filename, successcallback, failedcallback) {

    //self.pepApp.login.sendmsg_attempts += 1;
    //self.config.services.currentlyRunning += 1;

    var msgdata = {
      "recipient": recipient,
      "cc": cc,
      "replyto": replyto,
      "subject": subject,
      "body": body,
      "filecontent": filecontent,
      "filename": filename
    };

    $.ajax({
      url: self.config.services.ServiceEndpoint + 'sendmail',
      method: "POST",
      data: $.param(msgdata),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      dataType: "json",
      crossDomain: true,
      async: false
    }).done(function (data) {
      if (typeof successcallback != 'undefined') { successcallback(data); }
    }).fail(function (data) {
        if (typeof failedcallback != 'undefined') { failedcallback(data); }

      //if (self.sendmsg_attempts <= self.config.services.max_retrys) {
      //  //Try again in .75 seconds
      //  setTimeout(function () { self.sendmsg(recipient, cc, replyto, subject, body, filecontent, filename, successcallback, failedcallback); }, 750);
      //} else {
      //  //we're outside of our limit, return an error and reset trys'
      //  self.sendmsg_attempts = 0;
      //  if (typeof failedcallback != 'undefined') { failedcallback(data); }
      //}
    }).always(function (data) {
      //first show were doing something
      //self.config.services.currentlyRunning -= 1;
    });
  };


  this.getNotifications = function (successcallback, failedcallback) {
    //check the token

    self.notification_attempts += 1;
    self.config.services.currentlyRunning += 1;

    var username = self.data.login.token.username;
    $.ajax({
      url: self.config.services.ServiceEndpoint + 'getNotifications?username=' + username,
      method: "GET",
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      dataType: "json",
      crossDomain: true,
      async: false
    }).done(function (data) {
      if (data === null || data == '' || typeof data == 'undefined') {
        if (self.notification_attempts <= self.config.services.max_retrys) {
          setTimeout(function () { self.getNotifications(successcallback, failedcallback); }, 100);
        } else {
          self.notification_attempts = 0;
          if (typeof failedcallback != 'undefined') { failedcallback(data); }
        }
      } else {
        self.notification_attempts = 0;
        if (typeof successcallback != 'undefined') { successcallback(data); }
        // self.insertNotifications(data);
      }
    }).fail(function (data) {
      if (self.notification_attempts <= self.config.services.max_retrys) {
        setTimeout(function () { self.getNotifications(successcallback, failedcallback); }, 100);
      } else {
        self.notification_attempts = 0;
        if (typeof failedcallback != 'undefined') { failedcallback(data); }
      }
    }).always(function (data) {
      self.config.services.currentlyRunning -= 1;
    });
  };

  this.setNotificationAsRead = function (contentID) {
    var username = self.data.login.token.username;

    console.log("setNotificationAsRead " + contentID);

    $.ajax({
      url: self.config.services.ServiceEndpoint + 'setNotificationAsRead?contentID=' + contentID + '&username=' + username,
      method: "POST",
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      dataType: "json",
      crossDomain: true,
      async: true
    }).done(function (data) {
      //dont need to do anything
      //maybe pull notifications again or save

    }).fail(function (data) {
      //need to do a retry
    });
  };

  this.insertNotifications = function (d) {
    //clear the array first
    for (var mi = self.data.notifications.length - 1; mi >= 0; mi--) {
      //First item in array becoming null here
      self.data.notifications.pop();
    }

    $.each(d, function (i, o) {
      //pop each one back into the array
      self.data.notifications.push(o);

      //check if we have any we want to push into the phone
      try {
        var notificationID = o.ContentID;
        var deliveredList = pep.data.deliveredNotifications;
        if (deliveredList.indexOf(notificationID) == -1) {
          cordova.plugins.notification.local.schedule({
            id: i,
            title: o.Title,
            text: o.Text//,
            //smallIcon:"res://icon.png"
          });
          pep.data.deliveredNotifications.push(notificationID);
          // Send to notifications page

          cordova.plugins.notification.local.on('click', function (notification, state) {
            router.push("/notifications");
          });
        }


      } catch (err) {
        //console.log("Local Notification failed OR Cordova not running.");
      }
    });

    //self.save();
  };

  this.getNotificationFailed = function (d) {
    //No Notifications should be fine
  };

  //this.checkToken = function () {
  //  var now = new Date();

  //  if ((pep.data.login.token.expires < now) && (self.data.login.isLoggedIn)) {
  //    //Get a refresh
  //    var refresh_token = { "refresh_token": self.data.login.token.refresh_token };

  //    //Now call token generation
  //    $.ajax({
  //      url: self.config.services.ServiceEndpoint + 'refreshToken',
  //      method: "POST",
  //      dataType: "json",
  //      data: refresh_token,
  //      crossDomain: true,
  //      async: false
  //    }).done(function (data) {
  //      //check if we have an error object
  //      if (typeof data.access_token == 'undefined' || data.access_token == '' || data.access_token == null || data.access_token == 'null') {
  //        //Do nothing we'll check again on next call
  //      } else {
  //        var t = new Date();
  //        t.setSeconds(t.getSeconds() + (data.expires_in - 60)); //the expiry time minus a minute for comfort.
  //        //All was ok so we have can go ahead
  //        self.data.login.token.access_token = data.access_token;
  //        self.data.login.token.expires_in = data.expires_in;
  //        self.data.login.token.issued = Date.now();
  //        self.data.login.token.expires = t;
  //      }
  //    });
  //  }
  //};

  this.getMobileOperatingSystem = function () {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  }

  this.CordovaSavePdf = function (pdfName, pdfOutput, callback) {
    try {

    //documentsDirectory
    var dir = "";
    if (self.getMobileOperatingSystem() == "iOS") {
      dir = cordova.file.documentsDirectory;
    } else {
      dir = cordova.file.externalDataDirectory;
    }

    window.resolveLocalFileSystemURL(dir, function (dir) {
      dir.getFile(pdfName, { create: true, exclusive: false }, function (fileEntry) {

        fileEntry.createWriter(function (writer) {
            writer.onwrite = function (evt) {
              console.log("write success");

              if (typeof callback == "function")
                callback("Opening...");

              self.cordovaOpenPdf(pdfName, callback);
            };

            console.log("writing to file");
            if (typeof callback == "function")
              callback("Writing...");

            writer.write(pdfOutput);
          }, function () {
            if (typeof callback == "function")
              callback("Error on saving.");

            console.log("ERROR SAVEFILE");
          });

        });
      });
    } catch (e) { alert(e); };
  }

  this.cordovaOpenPdf = function (pdfName, callback) {
    try {

    console.log("resolveLocalFileSystemURL --- ");
      var dir = "";
      if (self.getMobileOperatingSystem() == "iOS") {
        dir = cordova.file.documentsDirectory;
      } else {
        dir = cordova.file.externalDataDirectory;
      }

    window.resolveLocalFileSystemURL(dir, function (dirEntry) {
      var link = dirEntry.nativeURL + pdfName;
      console.log("opening url: " + link);

      if (typeof callback == "function")
        callback("Done.");

        cordova.plugins.fileOpener2.open(link, 'application/pdf',
          {
            error: function (e) {
              alert('Error status: ' + e.status + ' - Error message: ' + e.message);
            },
            success: function () {
              //alert('file opened successfully');
            }
          });

      });

    } catch (e) { alert(e); };
  }

  this.createDocument = function (callback) {

    try {
      var logo = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQQAAABkCAYAAABgi07kAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAGatJREFUeNrsXQl8TNf3v9kttSYSYt+rllhqrf5oEIIfgpTW1lKUtvnTTWm1qn5oVZGSRlutllgiInZiiTRiV0vtIlFiV3uFZGL+57x5M3nzvJm5M3kzyZjz/XzO5828d++5555777n3nnvffYwRCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEgspwIxU4Fjdv3kyAS1vx704/P79epBVCYYEnqcCx8PX1LY0X8W9p0gjBKQ3C5cuXS8HlG6D/irfuAq0B+iQwMFBLquSG1sRvAsE5kJmZWV2r1Z4GeqQ1RhbQJnhOIw1ea6DVJkn0l0QaIThjJV6hNQ0N0NekJTIIBOeHu6UAGRkZFeDSw0wQD6BBpEoCwQUMQrVq1WrDxdtCsAqkSgLBBQwC4LFKYQgEgrMbhLp16x6GywMLwWguTCC4CrRabS+tedQlLXHrkpyKBKeeMrCGDRuug8urQDmyR+eAOsPz06RKAsH5wbV/4NixY5qgoKBVaBuOHDnSDK4lgS7CvRNwPQ/PSZMEgqsYBMTRo0c1cDndrFkzHBXgUuNjuEcaJBAIBPIhEFzWh0AgEGjKQChA7N69G9+EbA1UEai+ePs40H183Lp16wsOlKWKKAuilXjFl9tOAt1DuRwpTyEpm85AJSRlswfoIl5BF08cVAaY3iWxXhyDdB1jEFJSUiLh0sRMkF9ffvnlX6Q30tPTW126dGkW/NSYiRcH8eZYSh94lQReay2MaLBi9gR+mvwqBfKLl/VM5zw1hXOQ1htqFzykjaUa0apVq3pwLQtURKx4TDQGmL/bEA4dOCtFHTI7yFEZLr2BQkCWanAtIz7SXzUSee5D+PNwTQSKBHm0+UxbWt8OAb8IlfKUYq7OWlk2/mL70ZdNP6AssWwOwjUeaHN+ykYUty/QmybKANN7JJYDpot1diGkedHe895dFvYh/E8ep0uXLmXh/hML8W4lJydbTB94eUHYrVrLaK9Sfl/nSOs9NX0IqAegb+BempYfl4BiIZ5q5yoAL3dRjr+wfLTWAcPvg/gRPOXKWd92qViPzdZZMzpBiraibHKA/sY3gSFeHxvLoRPGF8uYF/ew3CDuZ/nRv7WVWAmTTMT7miMTr3HK8BIHr3w76ZKSkjCtExbS+bd9+/bF1TIIkGYp+L1BfJ1cCZkimcw38lAh7/WA1xYzckhlMSfPP5gf4FdSTaOpskGYxKkTL7FsckzoIh5ojxl9ZAKPxlaWw3sQ7zxHGdw1Yxg2qFEnVDUIwcHBvhyN+DiPDMDLE8LutMBLs23btqB85rU/h8zfqKTLJJAX721XKPC5uEMU8t0KKEikYLj3jonR0nbg5W2rXBC3BZaFifz+BjQoWIcgBXlWmYi3H/k6s0GAcL8oNLZPJOVSCag2/hZ39M5VMA4drCiHd0SDKscqhTJ4USyDqUB7TdSJUoXGIIhxYy21rs2bN7filKMnR2NdYGs+QQ5M45gF/g9DQkLKqaRLHBJOl/H/Gvg3BfIFeio+3PMEqgHhIhRk+87GfL8IcU8p8IuCtNoClVeSRSJPZQwH4Vcr8DgF/Cs6o0EAuVtDuGypgYN8tgQqakIXTCy3phD2M6D7YrxgznIYBWFvyo0q1ntRx6bKoCRQXTFNObZgvS5MBqEBRyPeyiNHly5dikDYc5bmURs3bvS3MZ/hHLLOVFGX2BP8K+l5BkMeS3LqwlPsnY2mMpD3mtbIA+FxunJSoRfsBWn4WcMLwldRkElo1JCOl7MZBNnI5wHkr54VuigK1ArixQC14SgHnK7dkMkYjWkCcadpQv/TCo1B6NatGzMxnDEa6q9bt64BpywfczTaj63NI6SPvI9aGh1AfvztoMvbQJ1RV9YAwqNRiJPx+tzKPK9QMAZWyyKT6V2FPM5wQoMg9aXMtVEfgUAlLJSDm+inkGItxPOzUf/j5R0FpFG1UBgEMX4IRyP+kUeWnj17+lpweiGuJCQkFLcyj705ZJxtJ12+BfmylV8joFwJrzP5yDM6zrraKoukjLBSjpHxfgBlUs9ZDALIWlMWvpMdnfadZWV4C3RYPR/6LyZONbT5NWh2MQhhYWEe4jKMOdyNj4/345RnDkfj7cebP0gXeR62wO8B5CPADrr8Afja7AyEuMhzm4TfE8hPVY48uyvk+RPkpwaAD3rnN8r4L3EWgwDP68vCh9rRIMidyu+rZGSMRn5Q5qUKhUEQebzH0Yg/4JGnT58+5Tl4HYqLi3PnzF8vDn6xdtDleciLGkZmkkzWVhxx/iOLg7I8p2ZFB37o/HwgPaUbyiTAGQwCyF5MFv4nexgD1IdsSfMBpF1CBd1jJ3xFloeQQmMQwsPDSyoc4y7H5djY2OKcMq3maMQWGwakhz3lIQ5eTe2gyz9U4ilffRnCESdSFmeCnXq/5bJ03nQiH4J0P8ptqCtD7KCfYbZMnTl5z7V2udxh7zKsWLECtxbjkuBoM8EqgOHAoVkcB8svmfnToBGfAXW3YKiaw8XSxpG1AwYM+NMOatGoxOea7H8VjjhdJb9zIH8/2anoo5jucB2DMxzoV+Yc+F6UH1Ea6sr0mJgYdCrPAH2plUY7eVlCGmr5K+7I/jdQy9Lke4SAGDhwYKBkmc0UDixatIiHF8+8XwO8mlnI21qO0UEzO/ljVOn9QBelZfJ+aS486KSMzIl1wl4tCmTzkm2BPu8sIwRRr7vlHnscnYIOBwAVUUGm9TL+6egYVonSZbx3FSqDIPJaydEAgzl5defgZbLn++2334LED82Yw7rBgwezwmwQbHCYtbCbB1o5vQNSI+0sBgEBZd9Q3Jr81PQWlwqhDk0Eqg9kq0zXtI6DRd0XxOvP+JUndGWb+/I07iPYbonRW2+9tfHnn38+Cz9rmwnWe8GCBZOHDRt2UaGwJzPd6U9mpya///47e8Ygdx5etXN6OCrQj7I8nElRUPZ/eXl5jYR6NhT+St+6xG+RVIA6hMN73LRxWKPR4Nmj66CuWZOEv2yIf9iO2fEodAZhxIgR+3788Ud8PfRFM8E6QJjGENascqCh50JB4Twv0kywskOHDu0HhfSt9CbwbyAWpDkkgwz72bOHJw6uB0aH8G7YsKFG165d051FWVDPjri7u6PTNRXqTR+ZTwR11xIJ6hkah0G5ubnYg6yHumNtUmcgzuhCrxA1pwwivzCO4c18Hl4jR44sw/GabkZ0dLSPTIYEDhlC7azLgpoytM9P+dkgW7TRcsaECQHOMmVQqG8VgfqLHvwLJuoNbq//Wl7nOGTa5hQWUm2DMGrUKA+Od8tvRkVFVeKUby5H435dHx741ufwHRwDOb2eUYPQSRZ+vJ3rj9EGJWfyIZipw88B4ZuGX+DysYk6tBLqmq8FmU5LX3ZzSYMg8hzD0YjH8vCKiIioxrGd+eCcOXOscWz2doAuC8og1FHrDVFO2c5I0sq1UkfbCqNBkNQ9pIZifVZ6PX+pvt6ZkGmH9LV3lzUIY8aM8RVf6jGHc7NmzfLhlJFn+bAt8Ktn4rALKU6AfJ7PqkGAvHnIdhDazakI+i4jG40d5siLtMdNKcwGQaJTJHyvZKLCBrwQMzL9Lg0I+irtkgZB5PsDRyN+lZNXWw5eaxTe7lNCXwfpsiB34SUbvdM9c+bzdsrvEJlsszjiSP07N5zBIOjx/vvvK+0+3GJGpsGysG+7rEEYN24cvlH22ALv/dOnT+fhhXKmWuCVzTE6OAm8PF3AIIyTxVmudl6x3BRefe/AIdssaQTgU1wFWdwc5UgV66J0lPPITNjysuluGsjq4ZIGQeTN02N34OTFc6KSJbzpQF0WmEEYP358VZlxzJk6dWqQynkNlb9ABekW4Yj3gSzeSyrIMsbBKysDpImBbmuaCSvfrTjClQ1CC45GyuV9/fTTT70UTv+xBteBRwlXMAhinMWyeIlTpkzxVkMe4IPb1OVnNH7IKVc7Wbw5+ZSlgYK/yt4GoQ3v7luF/F5CmdWUB/ghVSz0BmHixIlMYb+4HI8mT55ch1PWd/NhEL5wsHEtUIMAuq+psIdjLug6X0YB46N3Xcb3KKRXjlMufPVYeqLwVeAZaKMsaJhS1KyznOUxVpoY5MnfQhvYJJMvBWSvoYYswAenJTNUG3nY0yCI/HlOK/rJisxft8EY3IC4fq5kEMR4Soe1zoFK6mmjga+mcIDNQzyww8r8LJDxWAy8va2UJUBhFMSlI2zAQM2wsdqgA2/Zq9PnOeotLl3ekcm4EXi1zU9nC4TT6Hj9zMUpDAIOU2UbNBRPVILhfDlOeWfYYBC+LIDpV4EbBNA9OtuilHaKgr5fAuLig+GA/qtwNiBiMg5ZrawTdUVDYrRCAWkEcMqCJx9Lz5s8YeVeDVy12gf0GfDqCOTJqQdPuVOUt25hD67gZP8LeL4BxP2NCzH/HUU5pIekWDQIbryVGC7tzQT50s3NLb+jBHxxxNJc8SNI51tLvKZOnVp1/PjxaYx/j/4/06ZNqzdhwoQbjjAIEl3ugPy8opZBsLU8QF8+oC88L1K+5PUX0GrQyw64oj4vgZ40Esck+lvwc3MNgQfmAz+6U0HGIxrifAA8HtqQp6+Y7kwLKeKAF55etU8qD8iClxKiLKhfPBhS/02IuxCuF4RJ4tWR6MjWnwZ+DmgLpHtY1Anq4pYsbX8x7b4yPV6FcG0gbgZHOSAv3IyHy2rS0VAO0FLgsUvMN6Z/H/gyWd5riTIEifmXOzLfhjzPV6US23OEgJg+fXoFjqF+Bu+SIIRdZsXo4KsCctAWmm25oH8fHBWYWJY9K278mjdOAvj/q3j/skIcPL15IvLNR50oJsokxx25PNgLi/IckYXF/IyyVkfw/GUTdeWIeAqUPO3lop7kaQ+xMs/6VZZ7JtLfI+bzS0n6M8R7e7TG35HQA1+xnga8K6lV2VIc0aBMDF3lGMDJqwmnMciZOXOmvwMNQooDduHZVB6gBx+gCIVGZS12AJ9hQPnOF8oE/L4300DM4TTmRy+HNTqCONhB4Veb/rZRB0ZpW5lnpGGybc22AHW2Cni9pkZZSCsbzgvvmyFVzuObNWtWA3GUYC6tPzh5uXGMbBBxzIGQ6XKDinxVKw/QHX5Hc6a4m/E+75Ithoe4E4DqqKkz4Ic0XJTnOqcsqyFOp/zoSEwXnXILRX9CDkfa+AbkMnnaNua7DurTinzrRyX47shC1Jm1W6G5ht+RkZE/wCXBTJCDahT82LFjj7m7u+McytzONC0nL+2YMWMWWPB95ELePnekQZDp8oqKfD9QqzxAd6lQDqnws46ov/oRERH4nYAiMh9Bhph2hji33Q9xz6itM+CJl59AJvykcXOQBc8hLA+ElV3/afTbQHcksmyAeLfzoyMx3dWQ7mqm+zx9e0i7npm0j4tpr4e42SrkG3U5FdLHTgvP/mxhohywHj0S844rGihHoii/VXBjzzDEffNjzARJcHNzC2MEi4iKisLKjyctVZc5Hdno0aNvO1gWJjbGAJZ34tB1oGv2lqUg0zZTDmgIHji6HJwKI0eOrGzhPQlNdHR0A9IUgeACwPPtLcy1EkhLBIILYNiwYZUsjA5yFixY0JA0RSC4xujA0jkLm0lLBIILQPwYjKUzFoJJUwSCa4wO5lk6WzEmJoYURSA86wgPD6+gtfxB2Z6kKQLBNUYHkRaMweG4uDhSFIHwrCMsLCyA4yh22oREILjI6GC2pdFBQgJtPSAQnnl069bNX+EwDTleI00RCK4xOvje0ttvGzdufI40RSCYh6ezZ6B3797F4IJfxrloJtic0NDQB46UKyQkpDJVL7vhcWJi4nVSg/pw+rcdT58+XTEzM7M1/DT3zcDNHTp0eOhIufBgCqpedsMxNze3iaQGMgjONI3Rkhbshn1gEFqSGtSHO6mA4IR4SCogg0AgEMggEAgER8GTVFB4cOrMWZb9WHcUX7VqVVjJEnmfmbx//wFLP3+euYlun4YNXmAwjzY8R5fFX8dOCL+9fbzZ83VqG/HOyspiZ9PSdX8gXiOIL8WFi5nszp27wu8A/3IsIED5IOpr12+wa9eUHfzFihUFKsYCK5TnioPhvb29WZnSpVmJErQqTHiGYe152Q+zsrR1GjbXlvCrLNCsSOMT6f88dERbolwVw/PLV68aPc+8dNnwDPk8fmx8PP+GzVsNz59v1NL4LDmNRtstrJ/h+Yh3xpqUc+o3swzhnvOrpC3uqyP83bRVO22/gUO125KStTk5GotxMDym+/W3s7Vp59K1T5484VVXEtUwGiE800jakcKys7OZv7/ua3ULFy1lbw8fyooU0X3npEnjRqxZkyB2MfOS8D9l5272ap9ehvgbN20xxEU++w/8yV5qk+eIT9yy3fD8jcHGmzaPHz/Jjhw9bni+I3mnMCJR6rWLFy9mCOfh4SGQPs1r128Ko4HU3fvY/Lnfsa5dOpmNc+XqNYH2gazLVyaw72dOZ21a0+IB+RBcHLm5uSwWGgQ2FOglhXt3791jW5OSjcK99mofpl/NTNyaZDRdSNye9x/5rFi1xoh/yq7d4mzBjXUKfsUo7o+/LmI+MM3AtPG/JlfDFi1ZZlHuF+rVZX3Degj0SruXWdUqlcCAFYFpgBf7+NNJTGnlVRqnSeMgVqVyJVYcphn//HOLjR33GUtLz6AKQQbBtXH6TBrbul3X+EuXLiU0WmzUCxctERqzHt1DOzNPT92gLnXXXvbo0WPh99Vr19juvQcMDVz3fDfLyckRfqelnYMGpzuhu0JAAGvapJGB51WY22/dpjMmJUuWYJ6QLqa/NDaePXr82KzcoZ07ssmfjxfop6jZbPaMqQaj8++/D9m1GzfMxlm/ahmbMulT5ufrK+QL/QxTps6gCkEGwbURszxOmBpgYx49YhgL8Nc59PbtP8jOnE0zhAsMLM9q16qhG6LnZLM/UneJ04WtzMfbW4jv46ObYty8dZsdOHhY+L1uUyIYGF1Rh3bpaJT2mrUbWI5GI8Qd0C9c6MERODXZ8cdOs3JnZ+cY/W/+YtO8iuXuxi5fvvpUHL0R06NjcHs27sP/081fwSjshelDVtYjqhRkEFwTDx8+ZHHxq8W5dnHWv28Y69Oru/AfPfBLlq80Ct+1cyfh01XYC+unDVu27zA0qC6dgoXG7eHuzuLXrBPur12/2dBzYwPU4zHM+2Ni44T7OGXo2aMrGz5siMAfea1YuZo9yX1iUvZ79+8LvTrS5StX2S+/xRhGKSh708aNuHQQ1qObxMhks4OHjlDFIIPgmli8NJZpNLovrAe3f5m5QUNGZ6G7u65oVqxMAKORZQjfo3uoMKxH/LFzl9CToxMPUatGdfbR+xHMy8tL+H/w0GF26fIVdv6C7r2vgHLlWPNmTQy8klNS2YWLOidlvefrssoVK7KWLV5kXuK0JHHrdnY27ZxJ2VclrGMDh74tUO9+g9j4iZMFY4DGpHtoCLcO9E5GvdHy9PSgikEGwfWAvSFOF/T7Ce7cucP+98137IefFwqONgQO52OWxRriVKoYyGrW0H3F6+bNf9jMOfMEJ55uOtCJVSif5yPIyPibRQMvvQHB+bse6EBEY6N/5g4yfDX9W/bdnChhHwICpx8xsStNyn/j5k128tQZdur0GWF1AVclMA4athnTJnPrAX0gUoOAjklCwYCWHQsQydDDX7iQKfSQ6Dzcsj2Z5Wp0TkT0KXiIDr6YZXFsyMDX8xo+NGz0LeAoApcThV4WfveE0QMiPKwn27vvoG61YWVC3nShQ950IS0tnW2CuOh7yAXjsHvfAZaSukc0BN5CXOQfG7eKjf9wDCta9OlGWrZsGWHzFPoF0Dggqlerwn6INP3pcelmKv2U6ffFywxTjfIB/qxxI/rCHo0QXAzYQ6+MXyM0PGwIuLuvRrWqgtMQqXKlioZRwt8w5E8RHYiInt1CDVMK9AMgalSvJsRB/KdtG5g26Gy9fqXBH6YLLZs3M/BYGhcvGAPdVMKPVa9axZA2LgXi7kF9/KXLlQ+mxX0SOxLXssW/Rgs7FBEnTp6G8CuZqZc9cfpz6/ZtgXAPwrz5P7M58+aLPhAP9nr/cKocNEJwPZxLz2AbNm8RnG/Y+6YmbXoqzLzoBey7yHm6nj5+tbDWj4agSpVKggFIO5du6HG7dsmbs/v6lmWNgxoKqwz65/3C886XxR59eWy8Yf6esCJG6JmlwI1SI97VfU588bIVbNCAfgbfRB4f3WpArZo12KgRQ9nsyChkyCZNmc4aNXyB1X+h3lN5ik9Ya1i9wM1TuM26KEwRMF9tWrVkw4cOpspBIwTXwxKYm6PzDUcK/cN7K4Z57dXeQiPEMOs2JrJ0yaadLiEdhftI2JgG9O9rFBc3/uifo1HAUYVhdAA9fhY0ZnyGKwHlFd5baN26BfMtW1YIcy79PEtO2WUY1uv5SkcBw4cOEhyTeD8bRhUfTfhCSEMe59r16+z4iVMClSlTmpUqWVKYduCuyl/mf29waBJohOBS2Lotmfn5+eqmAN27KobBOXrH4HbC1l7Env0HWa1aNYXfvbqHsiXLVwi/n69bWwgrRfu2Lxn4VwoMZFWr5p3olrp7LysH0wTE0MEDFNMu4uMj+CRWrV2v83ekpAqy4NRAz1c/TUB4eXqxaVM+Z28Mf0f4j07GzYnbWK8e3YziSIFyoewdXvkPUDuqFIUAdGKSnUAnJtkVO2DU8wqpgaYMBAKBDAKBQCCDQCAQHApyKtoPOaQCu0FDKiCD4FTIysqi7wbYDxdIBQQCgUAgEAgEAoFAIBAIBYf/F2AAQYNHdjffywwAAAAASUVORK5CYII=";
      //const fonts = PDFfonts;

      //var weeksImages = [];

      // Get Names
      let firstname = "John";
      let surname = "Doe";

      if (pep.data.userdetail.FirstName !== '') {
        firstname = pep.data.userdetail.FirstName;
      }
      if (pep.data.userdetail.LastName !== '') {
        surname = pep.data.userdetail.LastName;
      }

      var fullName = firstname + " " + surname;

      // Create PDF
      const doc = new jsPDF('p', 'px', 'a4');
      var docWidth = doc.internal.pageSize.getWidth(); //446.46 px
      var docHeight = doc.internal.pageSize.getHeight(); //631.4175 px

      doc.setFillColor(30, 30, 28);
      doc.rect(0, 0, docWidth, 54, 'F');

      //IVYHOUSE LOGO
      doc.addImage(logo, 'PNG', 26, 14, 78, 30);

      //TOP BANNER TEXT
      doc.setFontType('bold');
      doc.setTextColor('#ffffff');

      doc.setFontSize(18);
      doc.text('MY ACTION PLAN', (docWidth - 280), 32);

      doc.setFontType('normal');
      doc.setFontSize(13);
      doc.text(fullName, (docWidth - 90), 30, {
        maxWidth: '80',
        lineHeightFactor: 1
      });

      var pozY = 84;

      var rowWidth = 50;
      var rowHeight = 46;

      var paddingX = 30;
      var paddingX_txt = 4;
      var paddingY_txt = 7;
      var testText = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In iaculis mollis leo, sed pharetra est luctus eu. Suspendisse et quam bibendum, posuere eros non, pellentesque odio.";
      var itemsPrinted = 0;

      //FIRST QUESTION
      doc.setTextColor('#1E1E1C');
      doc.setFontSize(12);
      doc.setFontType('bold');
      doc.text("What have I learned about myself?", paddingX, pozY - 10);

      doc.setFontType('normal');
      doc.setFontSize(8);

      doc.text('Page 1', (docWidth - 45), (docHeight - 30));

      pozY += 4;

      pep.data.categories.forEach(function (category, index) {
        if (category.answer1 != "") {
        }

        testText = category.answer1;

        var img = weeksImages[index];

        //row rectagle
        doc.rect(paddingX, pozY, (docWidth - 2 * paddingX), rowHeight, 'S');

        //image
        doc.addImage(img, 'PNG', paddingX, pozY, rowWidth, rowHeight);
        //image border
        //doc.rect(paddingX, pozY, rowWidth, rowHeight, 'S');

        doc.text(testText, paddingX + rowWidth + paddingX_txt, pozY + paddingY_txt, {
          maxWidth: (docWidth - 2 * paddingX - rowWidth - 2 * paddingX_txt),
          lineHeightFactor: 1
        });

        pozY += rowHeight;

        itemsPrinted++;

        if (itemsPrinted == 10) {
          doc.addPage();
          doc.text('Page 2', (docWidth - 45), (docHeight - 30));

          //HEADER---------------------
          doc.setFillColor(30, 30, 28);
          doc.rect(0, 0, docWidth, 54, 'F');

          //IVYHOUSE LOGO
          doc.addImage(logo, 'PNG', 26, 14, 78, 30);

          //TOP BANNER TEXT
          doc.setFontType('bold');
          doc.setTextColor('#ffffff');

          doc.setFontSize(18);
          doc.text('MY ACTION PLAN', (docWidth - 280), 32);

          doc.setFontType('normal');
          doc.setFontSize(13);
          doc.text(fullName, (docWidth - 90), 30, {
            maxWidth: '80',
            lineHeightFactor: 1
          });
          //HEADER---------------------

          doc.setFontType('normal');
          doc.setFontSize(8);
          doc.setTextColor('#1E1E1C');
          pozY = 100;
        }
      });

      //SECOND QUESTION
      doc.addPage();

      //HEADER---------------------
      doc.setFillColor(30, 30, 28);
      doc.rect(0, 0, docWidth, 54, 'F');

      //IVYHOUSE LOGO
      doc.addImage(logo, 'PNG', 26, 14, 78, 30);

      //TOP BANNER TEXT
      doc.setFontType('bold');
      doc.setTextColor('#ffffff');

      doc.setFontSize(18);
      doc.text('MY ACTION PLAN', (docWidth - 280), 32);

      doc.setFontType('normal');
      doc.setFontSize(13);
      doc.text(fullName, (docWidth - 90), 30, {
        maxWidth: '80',
        lineHeightFactor: 1
      });
      //HEADER---------------------

      pozY = 84;
      itemsPrinted = 0;

      doc.setTextColor('#1E1E1C');
      doc.setFontSize(12);
      doc.setFontType('bold');
      doc.text("What actions am I going to take?", paddingX, pozY - 10);

      doc.setFontType('normal');
      doc.setFontSize(8);
      pozY += 4;
      doc.text('Page 3', (docWidth - 45), (docHeight - 30));

      pep.data.categories.forEach(function (category, index) {
        if (category.answer2 != "") {
        }

        testText = category.answer2;

        var img = weeksImages[index];

        //row rectagle
        doc.rect(paddingX, pozY, (docWidth - 2 * paddingX), rowHeight, 'S');

        //image
        doc.addImage(img, 'PNG', paddingX, pozY, rowHeight, rowHeight);
        //image border
        doc.rect(paddingX, pozY, rowHeight, rowHeight, 'S');

        doc.text(testText, paddingX + rowHeight + paddingX_txt, pozY + paddingY_txt, {
          maxWidth: (docWidth - 2 * paddingX - rowHeight - 2 * paddingX_txt),
          lineHeightFactor: 1
        });

        pozY += rowHeight;
        itemsPrinted++;

        if (itemsPrinted == 10) {
          doc.addPage();
          doc.text('Page 4', (docWidth - 45), (docHeight - 30));

          //HEADER---------------------
          doc.setFillColor(30, 30, 28);
          doc.rect(0, 0, docWidth, 54, 'F');

          //IVYHOUSE LOGO
          doc.addImage(logo, 'PNG', 26, 14, 78, 30);

          //TOP BANNER TEXT
          doc.setFontType('bold');
          doc.setTextColor('#ffffff');

          doc.setFontSize(18);
          doc.text('MY ACTION PLAN', (docWidth - 280), 32);

          doc.setFontType('normal');
          doc.setFontSize(13);
          doc.text(fullName, (docWidth - 90), 30, {
            maxWidth: '80',
            lineHeightFactor: 1
          });
          //HEADER---------------------

          doc.setFontType('normal');
          doc.setFontSize(8);
          doc.setTextColor('#1E1E1C');
          pozY = 100;
        }
      });

      //SAVE FILE
      var pdfName = 'IvyHouseV2_ActionPlan.pdf';

      if (typeof cordova == 'undefined') {
        if (typeof callback == "function")
          callback("Done.")

        doc.save(pdfName);
      } else {
        var pdfOutput = doc.output("blob");

        self.CordovaSavePdf(pdfName, pdfOutput, callback);
      }
    } catch (e) {
      alert(e);
    }
  }

  //AEG
  //Save to Localhost

  //ASYNC FUNCTIONS NOT SUPPORTED ON IE 11
  //THIS CODE WAS COVERTED WITH BABEL ES6 TO ES5
  this.save = async (callback) => {
    console.log('save');
    if (self.saving === false) {
      if (typeof (Storage) !== "undefined") {
        self.saving = true;

        var mycallback = asyncSave(callback);

        if (typeof mycallback == 'function') { mycallback() };
      }
    }
  };

  function asyncSave(callback) {
    return new Promise(function (resolve) {
      setTimeout(function () {
        var dta = LZString.compressToUTF16(JSON.stringify(self.data)); //self.saveProfile(dta);

        localStorage.setItem('pepData', dta);
        //localStorage.setItem('homeviewed', JSON.stringify(pep.data.settings.storyboard_viewed));
        //localStorage.setItem('videos', JSON.stringify(pep.data.video));
        //localStorage.setItem("storedFlag", "true");

        self.saving = false;

        resolve(callback);

      }, 10000);
    });
  }

  this.restore = function (callback) {
    console.log("pep restore called.");

    if (typeof (Storage) !== "undefined" && typeof (localStorage) !== "undefined") {
      // Code for localStorage

      console.log("localStorage starting...");

      if (window.localStorage.getItem('pepData') !== null) {
        try {
          var string = LZString.decompressFromUTF16(localStorage.getItem('pepData'));
          self.data = JSON.parse(string);
          console.log("Data restored.");

        } catch (err) {
          console.log("Data restoration error. Clearing..");
          localStorage.clear();
        }
      }

      //whether we have full save or not, get essentials
      //if (localStorage.homeviewed) {
      //  self.data.settings.storyboard_viewed = JSON.parse(localStorage.getItem('homeviewed'));
      //}

      //if (localStorage.videos) {
      //  self.data.video = JSON.parse(localStorage.getItem('videos'));
      //}

      callback();
    } else {
      //Just fire up normally, we can't store stuff
      callback();

      console.log("Storage == undefined");
    }
  };

  //Initialise Vue, first check if we already have data, then launch
  self.restore(initPEP);

  //end of pep
};

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function validatePassword(str) {
  // at least one number, one lowercase and one uppercase letter
  // at least six characters
  var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;
  return re.test(str);
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

function touchHandler(event) {
  var touch = event.changedTouches[0];

  var simulatedEvent = document.createEvent("MouseEvent");
  simulatedEvent.initMouseEvent({
    touchstart: "mousedown",
    touchmove: "mousemove",
    touchend: "mouseup"
  }[event.type], true, true, window, 1,
    touch.screenX, touch.screenY,
    touch.clientX, touch.clientY, false,
    false, false, false, 0, null);

  touch.target.dispatchEvent(simulatedEvent);
  //event.preventDefault();
}

function initTouchToMouse() {
  document.addEventListener("touchstart", touchHandler, true);
  document.addEventListener("touchmove", touchHandler, true);
  document.addEventListener("touchend", touchHandler, true);
  document.addEventListener("touchcancel", touchHandler, true);
}

if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) { // detect it's IE11

  // url change routing for IE
  window.addEventListener("hashchange", function (event) {

    var currentPath = window.location.hash.slice(1);
    if (pep.getCurrentRoute() !== currentPath) {
      pep.gotoRoute(currentPath);
    }

  }, false);

}

// refresh gameplan iframe link
window.refreshIframeForDeeplinks = function (currentPath) {
  console.log("refreshIframeForGamePlan" + currentPath);

  if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) { // detect it's IE11
    if (currentPath.indexOf("actionplan") > -1) {
      if (window.frames.length != 0) {
        var iframeW = window.frames[0].frameElement.contentWindow.window;

        $(iframeW).ready(function () {
          iframeW.location.href = window.frames[0].frameElement.src;
          setPepObjToIframe();
        });
      }
    }
  } else {

    if (currentPath.indexOf("IvyHouse_ExtendedV2App") == -1 && currentPath.indexOf("IvyHouse_ExtendedV2App") == -1) {
      console.log(currentPath);
      console.log(currentPath.indexOf("IvyHouse_ExtendedV2App"));
      setPepObjToIframe();
    }

  }

}

window.setPepObjToIframe = function () {
  //set iframe pep equals to main window pep
  console.log("setPepObjToIframe>>");

  var frames = window.frames; // or // var frames = window.parent.frames;

  for (var i = 0; i < frames.length; i++) {
    var iframe = frames[i].frameElement.contentWindow.window;
    console.log("frame " + i);

    iframe.onload = function () {
      if (iframe.window.pep != null) {
        iframe.window.pep = window.pep;
        iframe.location.href = window.frames[0].frameElement.src;
        console.log("onload/location/pep done.");
      }
    };
  }
}

//localStorage.clear();

//Start PEP
window.pep = new PEP();

document.addEventListener('deviceready', window.pep.cordovainit);

initTouchToMouse();

//-------------AEG-----------------------//

//function setupQuestionnaire() {
//   // alert('AEG here 2');
//    //pep.data.userdetail = userdata;

//    catalogQuestionData = getQuestionnaireQuestions(1, 'Test');
//    var j = JSON.stringify(getQuestionnaireQuestions(1, 'Test'));
//    //alert(j);
//        if (catalogQuestionData !="") {
//            pep.data.questionnaire = catalogQuestionData;
//            //alert(catalogQuestionData);
//        } else {
//            router.push('/questionnaireComplete');
//        }

//}
//function getQuestionnaireQuestions(userid, questionnaire) {
//   // alert('AEG here 4 ' + questionnaire);
//    return $.ajax({
//        // url: self.config.services.ServiceEndpoint + 'questionnaireQuestions?userid=' + userid + '&questionnaire=' + questionnaire,
//        url: 'https://ivyhouselms-api.purplemediahosting.co.uk/classroomAPI/IvyHouse/questionnaireQuestions?userid=1&questionnaire=Test',
//        method: "POST",
//        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//        dataType: "json",
//        crossDomain: true,
//        async: true
//    })
//}
//function getQuestionnaireAnswers(qid) {
//    return $.ajax({
//        url: self.config.services.ServiceEndpoint + 'getQuestionnaireAnswers?qid=' + qid,
//        method: "POST",
//        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//        dataType: "json",
//        crossDomain: true,
//        async: true
//    })
//}

//-------------END AEG-----------------------//

/* ------------------------------------------------------------------------------
 *
 *  # Login pages
 *
 *  Demo JS code for a set of login and registration pages
 *
 * ---------------------------------------------------------------------------- */

// Setup module
// ------------------------------

var LoginRegistration = function () {

  //
  // Setup module components
  //

  // Uniform
  var _componentUniform = function () {
    if (!$().uniform) {
      console.warn('Warning - uniform.min.js is not loaded.');
      return;
    }

    // Initialize
    $('.form-input-styled').uniform();
  };

  //
  // Return objects assigned to module
  //

  return {
    initComponents: function () {
      _componentUniform();
    }
  };
}();

// Initialize Login and Registration module
// ------------------------------

document.addEventListener('DOMContentLoaded', function () {
  LoginRegistration.initComponents();
});
